module.exports = {"title":"답변 수정","replyStatus":"답변 여부","answered":"답변완료","checking":"확인중","contentPlaceholder":"내용을 입력하세요.","updatedAlert":"수정되었습니다.","typeService":"서비스","typeEvent":"이벤트","typeUpdate":"업데이트"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs106.json
// module id = Jfqw
// module chunks = 2